import AbstractReferenceSection from './AbstractReferenceSection';
import {List} from 'immutable';
import ImageRecord from './ImageRecord';

/**
 * ReferenceSection with 1 landscape image
 */
export class ReferenceSectionLandscape1 extends AbstractReferenceSection() {
  /**
   * @return {ImageRecord}
   */
  image() {
    return this._getOne('Layout', ImageRecord);
  }

  /**
   * Helper to keep consistent with other childs type.
   * @return {List<ImageRecord>}
   */
  images() {
    return new List([this.image()]);
  }
}

/**
 * ReferenceSection with 2 square images
 */
export class ReferenceSectionSquare2 extends AbstractReferenceSection() {
  /**
   * @return {List<ImageRecord>} Maximum of 2 image square
   */
  images() {
    return this._getMany('Layout', i => new ImageRecord(i));
  }
}

/**
 * Chroniqque with 2 portraits images
 */
export class ReferenceSectionPortrait2 extends AbstractReferenceSection() {
  /**
   * @return {List<ImageRecord>} Maximum of 2 image square
   */
  images() {
    return this._getMany('Layout', i => new ImageRecord(i));
  }
}



// WEBPACK FOOTER //
// ./src/models/ReferenceSection.js